export interface AccessibilityContextType {
  highContrast: boolean;
  toggleHighContrast: () => void;
  fontSize: number;
  increaseFontSize: () => void;
  decreaseFontSize: () => void;
  resetFontSize: () => void;
  reducedMotion: boolean;
  toggleReducedMotion: () => void;
  focusVisible: boolean;
  setFocusVisible: (visible: boolean) => void;
  screenReader: boolean;
  toggleScreenReader: () => void;
  keyboardNavigation: boolean;
  setKeyboardNavigation: (enabled: boolean) => void;
}

export interface AccessibilityProviderProps {
  children: React.ReactNode;
}

// Constantes de acessibilidade
export const ACCESSIBILITY_CONSTANTS = {
  DEFAULT_FONT_SIZE: 100,
  MIN_FONT_SIZE: 80,
  MAX_FONT_SIZE: 200,
  FONT_SIZE_STEP: 10,
  STORAGE_KEYS: {
    HIGH_CONTRAST: 'highContrast',
    FONT_SIZE: 'fontSize',
    REDUCED_MOTION: 'reducedMotion'
  }
} as const;

// Re-exportar o hook para facilitar o uso
export { useAccessibility } from './use-accessibility'; 